import Http from '@/http/bhiotrack';
import { serialize } from '@/utils';

const getEligibility = async (params = {}) => {
  const { data } = await Http.get(`/consultation/eligibility${serialize(params)}`);
  return data;
};

const getBalance = async () => {
  const { data } = await Http.get('/consultation/balance');
  return data;
};

const payAvulsa = async (payload) => {
  const { data } = await Http.post('/consultation/payment', payload);
  return data;
};

const getPayments = async (params = {}) => {
  const { data } = await Http.get(`/payment${serialize({ ...params, type: 'paid-consultation' })}`);
  return data;
};

const getCycles = async (params = {}) => {
  const { data } = await Http.get(`/consultation/cycles${serialize(params)}`);
  return data;
};

export const consultationService = {
  getEligibility,
  getBalance,
  payAvulsa,
  getPayments,
  getCycles,
};
